import type { KnowledgeArticle } from "../types"

export const aiIntegrerenBedrijfssoftware: KnowledgeArticle = {
  id: "insight:ai-integreren-bedrijfssoftware",
  pageType: "knowledge-article",
  slug: { nl: "ai-integreren-bedrijfssoftware" },
  title: {
    nl: "AI Integreren met Bestaande Bedrijfssoftware | Zo pak je het aan",
    en: "AI Integreren met Bedrijfssoftware | Zo pak je het aan",
  },
  description: {
    nl: "AI werkt pas als hij in de tools zit waarin je team al werkt. Hoe koppel je AI aan bestaande bedrijfssoftware zonder big-bang-projecten?",
    en: "AI only works when it lives inside the tools your team already uses. How do you connect AI to existing business software without big-bang projects?",
  },
  h1: {
    nl: "AI integreren met bestaande bedrijfssoftware",
    en: "AI integreren met bestaande bedrijfssoftware",
  },
  published: "2026-08-26",
  modified: "2026-08-26",
  author: "Camiel Schmeitz",
  sections: [
    {
      type: "paragraph",
      text: "De grootste rem op AI-adoption is zelden het model — het is de wrijving rondom. Als medewerkers voor hun antwoord naar een losse tool moeten, blijft het gebruik achter. Waarde komt wanneer AI in de workflow zelf zit: in het CRM, de ticketingomgeving of het publicatieplatform.",
    },
    {
      type: "heading",
      text: "Drie integratieniveaus",
    },
    {
      type: "list",
      items: [
        "Lezen: AI raadpleegt data uit een bestaand systeem (bijv. documentatie of klantgeschiedenis) om beter te antwoorden.",
        "Schrijven: AI legt resultaten terug in het systeem (bijv. labels, samenvattingen, conceptteksten) ter controle van een mens.",
        "Handelen: AI voert acties in systemen zelfstandig uit binnen afgesproken grenzen — de agent-vorm.",
      ],
    },
    {
      type: "heading",
      text: "Begin bij 'lezen'",
    },
    {
      type: "paragraph",
      text: "Het veiligste en vaak meest waardevolle niveau is lezen: retrieval over jouw eigen documentatie en data. Geen schrijfrechten, dus geen risico op kapotte records — maar wel direct merkbaar minder zoeken. De navigatieassistent die we voor Burgerkracht bouwden is hiervan een voorbeeld: hij leest de kennisbank en verwijst door, hij past niets aan.",
    },
    {
      type: "heading",
      text: "Praktische aandachtspunten",
    },
    {
      type: "list",
      items: [
        "API's eerst: bestaat er een gedocumenteerde API? Dan is integratie doorgaans haalbaar. Zo niet, dan wordt export/import-paden evalueren stap één.",
        "Rechten model: AI erft de rechten van de aanroepende gebruiker, niet meer. Bouw nooit een service-account dat méér mag dan de gebruiker.",
        "Randgevallen: dubbele records, lege velden en vreemde formats kosten in de praktijk meer tijd dan de happy path.",
        "Terugdraaibaarheid: schrijfacties moeten traceerbaar en ongedaan maakbaar zijn.",
      ],
    },
    {
      type: "heading",
      text: "Vermijd de big bang",
    },
    {
      type: "paragraph",
      text: "Grote vervangingsprojecten zijn riskant en traag. Effectiever is het toevoegen van AI-capaciteit aan bestaande systemen: een automatiseringsstap hier, een assistent daar, telkens meetbaar. Zo bouw je tegelijk vertrouwen bij het team en kennis over wat werkt in jouw organisatie.",
    },
    {
      type: "callout",
      title: "Checklist voor je start",
      text: "Welke systemen raken we? Bestaat er een API? Welke rechten zijn minimaal nodig? Wat is het terugrolplan? Kunnen deze vier vragen beantwoord worden, dan is de integratie meestal overzichtelijk.",
    },
  ],
  relatedServiceIds: ["ai-development", "ai-automation"],
  relatedCaseIds: ["de-limburger", "burgerkracht"],
}
